/**
 * InfoTip 气泡定位计算（纯函数，不依赖 DOM）
 *
 * 抽出来的原因：「气泡不会被卡片裁剪、也不会溢出屏幕边缘」这句话必须是可验证的。
 * 放在组件里靠肉眼试是试不全的 —— 老人机 320px 宽、平板 768px、按钮贴着右边缘
 * 这些组合一旦漏掉就是线上真事故。纯函数可以直接跑断言把边界全扫一遍。
 */

export const PANEL_MAX_WIDTH = 340; // 气泡最大宽度
export const VIEWPORT_MARGIN = 12;  // 气泡与屏幕边缘的最小安全距离
export const BUTTON_GAP = 8;        // 气泡与「？」按钮之间的间距

/**
 * @param {Object} p
 * @param {{left:number,right:number,top:number,bottom:number}} p.btnRect 「？」按钮的视口坐标
 * @param {number} p.panelHeight 气泡渲染后的高度（用于判断下方是否放得下）
 * @param {number} p.vw 视口宽
 * @param {number} p.vh 视口高
 * @returns {{left:number, top:number, width:number, placement:'bottom'|'top'}}
 *   placement 是给 CSS 用的：气泡在按钮下方还是上方，
 *   决定那条"透明搭桥"贴在气泡的哪一边（见 global.css 里的 .info-tip-panel::before）。
 */
export function computeTipPosition({ btnRect, panelHeight = 0, vw, vh }) {
  const width = Math.min(PANEL_MAX_WIDTH, vw - VIEWPORT_MARGIN * 2);

  // —— 水平 ——
  // 默认从按钮左边缘向右展开
  let left = btnRect.left;
  if (left + width > vw - VIEWPORT_MARGIN) {
    // 右侧放不下 → 改为与按钮右边缘对齐，向左展开
    left = btnRect.right - width;
  }
  // 仍未装进视口（按钮贴着屏幕边）→ 直接夹紧
  left = Math.max(VIEWPORT_MARGIN, Math.min(left, vw - width - VIEWPORT_MARGIN));

  // —— 垂直 ——
  // 默认在按钮下方；下方高度不够就翻到按钮上方；上下都不够则夹紧到视口内
  let placement = 'bottom';
  let top = btnRect.bottom + BUTTON_GAP;
  if (panelHeight && top + panelHeight > vh - VIEWPORT_MARGIN) {
    const above = btnRect.top - BUTTON_GAP - panelHeight;
    if (above >= VIEWPORT_MARGIN) {
      top = above;
      placement = 'top';
    } else {
      // 上下都放不下（气泡比视口还高），只能夹紧，按下方处理
      top = Math.max(VIEWPORT_MARGIN, vh - panelHeight - VIEWPORT_MARGIN);
    }
  }

  return { left, top, width, placement };
}
